/** Align with backend `MessagingEventKey` / notification types. */
export const MESSAGING_EVENTS = [
  { key: 'INVITATION_SENT', label: 'Invitation sent (broadcast)' },
  { key: 'BROADCAST_SENT', label: 'Broadcast completed (agency notice)' },
  { key: 'INVITATION_RESPONDED', label: 'Invitation response / production approval / modification' },
  { key: 'SCRIPT_SUBMITTED', label: 'Script submitted for brand review' },
  { key: 'SCRIPT_APPROVED', label: 'Script approved by brand' },
  { key: 'CONTENT_SUBMITTED', label: 'Submission / deliverable submitted' },
  { key: 'CONTENT_REVISED', label: 'Revision requested (script or video)' },
  { key: 'CONTENT_APPROVED', label: 'Content approved' },
  { key: 'JOB_CREATED', label: 'Job created' },
  { key: 'JOB_OPENED', label: 'Job opened' },
  { key: 'SHORTLIST_READY', label: 'Shortlist ready' },
] as const;

export type MessagingEventKey = (typeof MESSAGING_EVENTS)[number]['key'];

export const TEMPLATE_VARIABLES = [
  '{{campaignName}} — Job title',
  '{{kolName}} — Creator name',
  '{{agencyName}} — Managing agency or brand name',
  '{{brandName}} — Brand organization name',
  '{{actorName}} — User who triggered the action',
  '{{action}} — e.g. accepted, approved_for_production',
  '{{comment}} — Revision comment when applicable',
  '{{count}} — e.g. number of invites broadcast',
  '{{actionLink}} — Deep link when you add it to payload',
  '{{invitationUrl}} — Link to this invitation (set on broadcast)',
  '{{kolEmail}} — Invite email (when included in payload)',
  '{{dashboardUrl}} — Link to KOL dashboard',
] as const;

export const EXTERNAL_TEMPLATE_CHANNELS = ['WHATSAPP', 'EMAIL', 'SMS'] as const;
